export class Allocation {
    month: number;
    year: number;
    all_no_of_employees: number;
    category: string;
    category_id: number;
    no_of_employees: number;
    percentage: number;
    project_count: number;
    spent_hours: number;

    list: any;
    grid: any;
}



// WEBPACK FOOTER //
// ./src/app/modules/models/allocation.ts